var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.goBack}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-keyboard-return")]),_vm._v("\n    "+_vm._s(_vm.languageData.backBtn)+"\n  ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }